<template>
  <div class="my-2">
    <div class="text-common-grey -mb-2 font-light">
      {{ $t("Component Categories") }}
    </div>
    <div class="flex flex-wrap mt-0 -ml-4">
      <div v-for="category in categories" :key="category.id" class="ml-5 mt-4 cursor-pointer" @click="$emit('categorySelect', category.id)">
        <div class="flex space-x-3 w-44 items-center">
          <div
            class="min-w-14 min-h-14 w-14 h-14 rounded-md flex items-center justify-center"
            :style="{ background: `linear-gradient(to bottom, ${category.background_color_1}, ${category.background_color_2})` }">
            <component
              :is="category.icon"
              v-if="category.icon"
              class="w-8 h-8 transition ease-in-out hover:text-dark-body-text text-common-grey duration-side-menu-transition-duration"
              aria-hidden="true" />
          </div>
          <div class="mt-2 flex flex-col justify-between h-14">
            <div class="leading-4 w-20">
              {{ category.group_name }}
            </div>
            <div class="text-common-grey">
              {{ category.group_name == "Portfolio Overview" ? $store.state.object_types.length : category.components.length }}
              {{ $t("component") }} {{ category.components.length > 1 || category.group_name == "Portfolio Overview" ? "s" : "" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PortfolioOverviewGroupIcon from "@/components/shared/icons/PortfolioOverviewGroupIcon.vue"
import Customer360GroupIcon from "@/components/shared/icons/Customer360GroupIcon.vue"

import InsightsGroupIcon from "@/components/shared/icons/InsightsGroupIcon.vue"
import RevenueGroupIcon from "@/components/shared/icons/RevenueGroupIcon.vue"
import ExpansionGroupIcon from "@/components/shared/icons/ExpansionGroupIcon.vue"
import LifecycleGroupIcon from "@/components/shared/icons/LifecycleGroupIcon.vue"
import ResourcesGroupIcon from "@/components/shared/icons/ResourcesGroupIcon.vue"
import AIComponentsIcon from "@/components/shared/icons/AIComponentsIcon.vue"

export default {
  components: {
    PortfolioOverviewGroupIcon,
    Customer360GroupIcon,
    InsightsGroupIcon,
    RevenueGroupIcon,
    ExpansionGroupIcon,
    LifecycleGroupIcon,
    ResourcesGroupIcon,
    AIComponentsIcon
  },
  props: {
    categories: null
  },
  emits: ["categorySelect"],
  data() {
    return {}
  },
  watch: {},

  created() {},

  methods: {}
}
</script>
